var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabs',{attrs:{"parent":"airalo_list"}},[_c('tab',{attrs:{"id":"simcard_list","name":_vm.translate('airalo.simcard_list'),"href":_vm.url+'simcard_list'}},[_c('SimcardList')],1),_c('tab',{attrs:{"id":"order_list","name":_vm.translate('airalo.order_list'),"href":_vm.url+'order_list'}},[_c('OrderList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }